
export interface Form {
    id: number;
    name: string;
    formSections: FormSection[];
    formUploads: FormUpload[];
}

export interface FormSection {
    id: number;
    formId: number;
    sequence: number;
    name: string;
    maximumSectionRows: number;
    defaultSectionRows: number;
    startOnNewPage: boolean;
    showSectionHeader: boolean;
    showSectionDivider: boolean;
    rowsPerPage: number;
    formSectionFields: FormSectionField[];
}

export interface FormSectionField {
    id: number;
    formSectionId: number;
    sequence: number;
    name: string;
    displayName?: string;
    fieldType: FieldType;
    fieldLength: number;
    fieldHeight: FieldHeight;
    keyField: KeyField;
    required: boolean;
    primaryEmailAddress: boolean;
    formSectionFieldValues: [];
}

export enum FieldType {
    TEXT_INPUT = 'TEXT_INPUT',
    TEXT_AREA = 'TEXT_AREA',
    YES_NO = 'YES_NO',
    CHECKBOX = 'CHECKBOX',
    DATE = 'DATE',
    EMAIL = 'EMAIL',
    SPACER = 'SPACER',
    RADIO = 'RADIO',
    SELECT = 'SELECT'
}

export enum FieldHeight {
    QUARTER = 'QUARTER',
    HALF = 'HALF',
    FULL = 'FULL'
}

export enum KeyField {
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    EMAIL = 'EMAIL',
    PHONE = 'PHONE'
}

export interface FormUpload {
    id: number;
    formId: number;
    sequence: number;
    name: string;
    allowedUploads: number;
}

export interface FormSubmission {
    id: string;
    formId: number;
    submittedOn?: Date | null;
    url: string;
    saveForLater: boolean;
    formSubmissionFields: FormSubmissionField[];
    formSubmissionUploads: FormSubmissionUpload[];
    userSavedFormOn?: Date;
    printedToPdf: boolean;
}

export interface FormSubmissionField {
    id: number;
    formSubmissionId: string;
    formSectionFieldId: number;
    formSectionField: FormSectionField;
    formSectionRow: number;
    fieldValue: string;
}

export interface FormSubmissionUpload {
    id: number;
    formSubmissionId: string;
    formUploadId: number;
    s3Key: string
}

export interface FormSubmissionUploadViewModel {
    formSubmissionId: string;
    formUploadId: number;
    formUpload: FormUpload;
    s3Keys: string[];
    complete: boolean;
}

export interface FormSectionViewModel extends FormSection{
    formSectionRows: FormSectionRow[];
}

export interface FormSectionRow {
    sectionGridRows: SectionGridRow[];
}

export interface SectionGridRow {
    left: FormSubmissionField;
    right?: FormSubmissionField;
}
